import { ReactNode } from 'react';
import { useStepByStep } from './StepByStep.hooks';

export type StepProps<T = string> = {
  name: T;
  children?: ReactNode;
};
export function Step<T = string>({ name, children }: StepProps<T>) {
  const { step } = useStepByStep<T>();
  return <>{step === name && children}</>;
}
